<template>
  <div id="app">
    <mobileHeaders
      v-if="
        headerRoutes.indexOf($route.name) < 0 &&
        $utile._isMobile() &&
        currentRoute != '/darenMonitor' &&
        currentRoute != '/darenDetails' && 
        currentRoute != '/earlyWarn' &&
        currentRoute != '/brandPublicOpinion' &&
        currentRoute != '/pointsDetails' &&
        currentRoute != '/deductionExplanation' &&
        currentRoute != '/personalData'
      "
    ></mobileHeaders>
    <headers
      v-if="
        (headerRoutes.indexOf($route.name) < 0 &&
          $utile._isMobile() === null) ||
        currentRoute == '/darenMonitor' ||
        currentRoute == '/darenDetails' ||
        currentRoute == '/earlyWarn' ||
        currentRoute == '/brandPublicOpinion' ||
        currentRoute == '/pointsDetails' ||
        currentRoute == '/deductionExplanation' ||
        currentRoute == '/personalData'
      "
    ></headers>
    <router-view />
    <bottom
      v-if="
        (headerRoutes.indexOf($route.name) < 0 &&
          $utile._isMobile() === null) ||
        currentRoute == '/darenMonitor' ||
        currentRoute == '/darenDetails' ||
        currentRoute == '/earlyWarn' ||
        currentRoute == '/brandPublicOpinion' ||
        currentRoute == '/pointsDetails' ||
        currentRoute == '/deductionExplanation' ||
        currentRoute == '/personalData'
      "
    ></bottom>
    <mobileBottom
      v-if="
        headerRoutes.indexOf($route.name) < 0 &&
        $utile._isMobile() &&
        currentRoute != '/darenMonitor' &&
        currentRoute != '/darenDetails' &&
        currentRoute != '/earlyWarn' &&
        currentRoute != '/brandPublicOpinion' &&
        currentRoute != '/pointsDetails' &&
        currentRoute != '/deductionExplanation' &&
        currentRoute != '/personalData'
      "
    ></mobileBottom>
  </div>
</template>
<script>
import headers from "@/components/head.vue";
import mobileHeaders from "@/components/mobile_head.vue";
import bottom from "@/components/bottom.vue";
import mobileBottom from "@/components/mobile_bottom.vue";
export default {
  components: {
    headers,
    bottom,
    mobileHeaders,
    mobileBottom,
  },
  data() {
    return {
      headerRoutes: ["帆扬宇亿科技-舆情监测系统"],
      currentRoute: "",
    };
  },
  updated() {
    this.currentRoute = this.$route.path
    console.log(this.currentRoute);
  },
  mounted() {
    this.currentRoute = this.$route.path
    console.log(this.currentRoute);
    // this.$nextTick(() => {
    //   if (
    //     this.$utile._isMobile() !== null &&
    //     /login/.test(window.location.hash)
    //   ) {
    //     // 手机端
    //     this.$router.replace("/mobile/login");
    //   } else if (
    //     this.$utile._isMobile() === null &&
    //     /login/.test(window.location.hash)
    //   ) {
    //     // pc端
    //     this.$router.replace("/login");
    //   }
    // });
  },
  methods: {},
};
</script>

<style lang="less">
.customClass{
  top: 90px !important;
}
body {
  width: 100%;
  height: 100%;
  margin: 0;
  background: rgb(247, 247, 247);
  margin: 0 auto;
}
h1,
h2,
h3,
h4,
h5,
p {
  margin: 0;
  font-size: 14px;
}
* {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
/*修改滚动条样式*/
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  /**/
}
::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #333;
}
::-webkit-scrollbar-corner {
  background: #179a16;
}
#app {
  height: 100%;
}
html {
  height: 100%;
}
i {
  font-style: normal;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
</style>
